goog.provide('el8.appshared.feedItemActionsNew');

goog.require('el8.appchart.actions.medOrder');
goog.require('el8.appchart.actions.medOrderNew');
goog.require('el8.appchart.actions.dcMedOrderNew');
goog.require('el8.appchart.dialog.addDiscreteLabValues');
goog.require('el8.appchart.dialog.addEditProblem');
goog.require('el8.appchart.dialog.changeDocumentSubType');
goog.require('el8.appchart.dialog.editReportDetails');
goog.require('el8.appchart.dialog.ordermed.document');
goog.require('el8.appchart.dialog.prenatalFlowsheet');
goog.require('el8.appchart.dialog.refaxLetter');
goog.require('el8.appchart.dialog.reports');
goog.require('el8.appchart.letters.dialog.updateUnreadAlertNotification');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.appchart.mgr.orderForm');
// goog.require('el8.appchart.mgr.thirdpane'); - bizarre circular dependency
goog.require('el8.appchart.refpanel.confidential');
goog.require('el8.appchart.refpanel.history');
goog.require('el8.apphome.dialog.patientCheckin');
goog.require('el8.appshared.dialog.reassignPatient');
goog.require('el8.appshared.dialog.reassignReviewUser');
goog.require('el8.appshared.message');
goog.require('el8.data.practiceUsers');
goog.require('el8.data.currUser');
goog.require('el8.model.identify');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.letterReceipts');
goog.require('el8.ptdata.letters');
goog.require('el8.ptdata.ptProblems');
goog.require('el8.ptdata.documentReminderNotifications');
goog.require('el8.render.content');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.alertConfirm');
goog.require('el8.uiwidget.deleteConfirm');
goog.require('el8.util.amplitude.letterHelpers');
goog.require('el8.util.amplitude.orderHelpers');
goog.require('el8.util.amplitude.patientChartHelpers');
goog.require('el8.util.consts');
goog.require('el8.util.feed');

// TODO NewChartFeed
//   - replace el8.appshared.feedItemActions with this after transition
//   - reduce duplication with el8.appchart.mainFeeds.actions triggers


//
// Returned fn takes two params:
// - item
// - fromRA - indicates was called from an RA item and used to define variant menus for them (medOrder)
//
el8.appshared.feedItemActionsNew = (function() {

    var currUserIsBillDelegateOfSigner = function(signUserId) {
        // The "true" argument = don't fetch from server:
        //
        // We've already loaded the practiceUser set locally at the start of appchart.js,
        // so if we don't get a result, this person is either A. in another practice or
        // B. has been deactivated and we stopped loading inactive users on chart load
        // (as of 5/15 we load inactive users too). In either case, we cannot be their
        // bill delegate.
        var signUser = el8.data.practiceUsers.getById(signUserId, true);
        if (!signUser) { return false; }
        return _.contains(el8.data.currUser.getBillDelegatingPhysicianIds(), signUser.getStaffId());
    };

    var showAddEditAmendmentRequestDialog = function(note) {
        el8.appchart.dialog.addEditAmendmentRequest.show({
            getAmendmentRequestFn: function() {
                return note.getAmendmentRequest();
            },
            saveAmendmentRequestFn: function(_request, saveCb) {
                note.saveAmendmentRequest({
                    amendmentRequest: _request,
                    successCb: function(request) {

                        // Refresh display of visit note in chart feed
                        el8.ptdata.visitNotes.itemNotify(note);

                        if (request.isAccepted()) {
                            el8.appchart.mgr.notes.amendVisitNote(note);
                        }
                        if (saveCb) { saveCb(); }
                    }
                });
            }
        });
    };

    var addConfidentialityAction = function(item, menu, right) {
        menu.push({
            actionText: item.isConfidential() ? 'Unmark Confidential' : 'Mark Confidential',
            actionFn: function() {
                var oldConfidentiality = item.isConfidential();
                var inverseConfidentiality = !oldConfidentiality;
                item.saveConfidentiality(inverseConfidentiality);
            },
            right: right ? true : false
        });
    };

    var addPrintSpecimenLabelsAction = function(item, menu) {
        menu.push({
          actionText: 'Print Specimen Labels',
          actionFn: function() {
              var printPath = el8.service.urls.get('printSpecimenLabels', [item]);
              if (el8Globals.APP === 'chart') {
                  el8.appchart.printService.open({
                      attachmentId: item.getId(),
                      url: printPath
                  }, true);
              } else {
                  window.open(printPath);
              }
              return false;
          },
          allowReadonly: true
      });
    }

    var addDYMOLabelPrintingAction = function(item, menu) {
        if (el8Globals.APP === 'chart') {
            menu.push({
                actionText: 'Print DYMO Specimen Labels',
                actionFn: function(item) {
                    el8React.dispatch.openDymoPrintSpecimenLabelDialog({ labOrderId: item.getId() });
                }
            });
        }
    }

    /**
     * Conditionally adds specimen collection action items to the menu based on 
     * collection datetime and in-house vendor status
     * @param {object} item - the item that the action is being taken upon
     * @param {object[]} menu - the entire menu reference object
     * @param {string} source - The view in which these actions are rendered for analytics
     */
    var addSpecimenCollectionActions = function(item, menu, source) {
      if (item.getModelClass() !== 'LabOrder' || !item.isIsInHouse()) return;
      var collectionDatetime = item.rawData.collectionDatetime;

      menu.push({type: 'heading', actionText: 'Specimen Collection:'});

      if (!collectionDatetime) {
        menu.push({
          actionText: 'Document Collection',
          actionFn: function() {
            el8React.dispatch.openSpecimenCollectionDialog({ labOrderId: item.getId() });
            el8.util.amplitude.logLabOrderActions('Document Collection', source);
          },
          indent: true
        });
      } else {
        menu.push({
          actionText: 'Edit Collection',
          actionFn: function() {
            el8React.dispatch.openSpecimenCollectionDialog({
              collectionDatetime: collectionDatetime,
              labOrderId: item.getId(),
              specimenCollectedBy: item.getSpecimenCollectedBy() || null,
            });
            el8.util.amplitude.logLabOrderActions('Edit Collection', source);
          },
          indent: true
        });
        menu.push({
          actionText: 'Delete Collection',
          actionFn: function() {
            el8React.dispatch.openDeleteSpecimenCollectionDialog({ labOrderId: item.getId() });
            el8.util.amplitude.logLabOrderActions('Delete Collection', source);
          },
          indent: true
        });
      }
    }

    var addOrderStatusActions = function(order, menu, source) {
        //
        // Add menu items allowing the user to change the order's resolution status
        //
        var currentState = order.getCurrentState();

        menu.push({type: 'heading', actionText: 'Order Status:'});
        menu.push({
            actionText: currentState === 'fulfilled' ? 'Fulfilled: Change Report' : 'Fulfilled',
            actionFn: function() {
                el8.util.amplitude.logChangeOrderStatus(
                    currentState === 'fulfilled' ? 'fulfilled change report' : 'fulfilled',
                    source,
                    order.getModelClass()
                );
                el8.app.shared.dialog.reportAttachments.show({
                    callbackFn: function (attachmentItems) {
                        if (attachmentItems.length) { // just one or none
                            var attachment = attachmentItems[0];

                            order.fulfill({
                                resolvingDocumentId: attachment.getId(),
                                successCb: function() {
                                    el8.appchart.mainFeeds.chart.update();
                                    el8.appchart.mainFeeds.reqAct.update();
                                    el8.appchart.mainFeeds.outstanding.update();
                                }
                            });
                        }
                    },
                    patientId: el8.ptdata.currPatient.getId()
                });
            },
            indent: true
        });

        if (currentState !== 'cancelled') {
            menu.push({
                actionText: 'Canceled',
                actionFn: function() {
                    el8.util.amplitude.logChangeOrderStatus(
                        'canceled',
                        source, order.getModelClass()
                    );
                    order.cancel({
                        successCb: function() {
                            el8.appchart.mainFeeds.chart.update();
                            el8.appchart.mainFeeds.reqAct.update();
                            el8.appchart.mainFeeds.outstanding.update();
                        }
                    });
                },
                indent: true
            });
        }
        menu.push({type: 'line'});
    }

    var addOrderReorderAction = function(order, menu) {
        //
        // Add menu item allowing the user to reorder an existing order
        //
        if (order.is('ReferralOrder')) {
            menu.push({
                actionText: 'Reorder',
                actionFn: function() {
                    order.reOrderWithLetter({
                        successCb: function(updatedLetter) {
                            el8.appchart.mgr.thirdpane.showLetter({ letter: updatedLetter });
                            // manually log create letter event in amplitude
                            el8.util.amplitude.logStartLetter('Referral Reorder', el8.util.consts.REFERRAL_LETTER);
                        }
                    });
                }
            });
        } else if (order.is('LabOrder') && (!el8.data.practiceUsers.isMember(order.getSignUserId()))){
            menu.push({
                actionText:'Reorder',
                actionFn: function() {
                    el8.uiwidget.alertConfirm(
                        "Reorder could not be completed because this lab order came from outside your practice. Please create a new lab order to send again.",
                        null,
                        function() {
                            el8.appchart.mgr.orderForm.showLabOrderForm();
                        },
                        'Create New Lab Order'
                    );
                }
            })
        } else {
            menu.push({
                actionText: 'Reorder',
                actionFn: function() {
                    el8.appchart.mgr.orderForm.reOrderItem(order);
                }
            });
        }
    }


    return function(item, fromRA, source) {
        if (!item) { return null; }
        var menu = [];
        var isPatientFormCollection = el8.model.identify.isPatientFormCollection(item);

        // Special short menu for preview visit notes
        if (el8.model.identify.isVisitNote(item) &&
            item.isPreview() &&
            (!item.isSignedOff() || item.getCurrentEditId())) {

            if (el8.data.currUser.isPhysician()) {
                if (!item.isSignedOff()) {
                    menu.push({actionText: 'Sign Off', actionFn: function() { item.sign(); }});
                } else if (item.getCurrentEditId()) {
                    menu.push({
                        actionText: 'Sign Amended',
                        actionFn: function() {
                            var note = el8.ptdata.tempVisitNotes.getById(item.getId());
                            note.sign();
                        }
                    });
                }
            }

            if (!item.isSignedOff()) {
                // edit a note preview (non-physician can do this)
                menu.push({
                    actionText: 'Edit',
                    actionFn: function() {
                        el8.appchart.visitNote.main.editPreviewedNote(item.getId());
                    }
                });
            } else if (item.getCurrentEditId()) {
                // amend edit and print
                menu.push({
                    actionText: 'Edit',
                    actionFn: function() {
                        var itemId = item.getId();
                        var editId = el8.ptdata.tempVisitNotes.getById(itemId).getCurrentEditId();
                        var edit = el8.ptdata.visitNoteEdits.getById(editId);
                        var note = edit.getVisitNote(true); // force fetch from server
                        el8.appchart.mgr.notes.amendVisitNote(note);
                    }
                });
            }

            // right
            menu.push({
                actionText: 'Print',
                actionFn: function() {
                    item.printNote(false);
                },
                right: true,
                allowReadonly: true
            });

            menu.push({type: 'line', right: true});

            menu.push({
                actionText: 'Remove',
                actionFn: function() {
                    el8.uiwidget.deleteConfirm("note",
                        function() { el8.ptdata.visitNotes.forceDeleteItem(item); }
                    );
                },
                right: true,
                type: 'remove'
            });

        } else if (el8.model.identify.isVisitNote(item)) {
            //
            // Regular visit notes
            //
            var bill = item.getBill();

            //
            // Left column
            //

            // send
            menu.push({type: 'heading', actionText: 'Send:'});

            // Was "send-letter-trigger" menu
            menu.push({
                actionText: 'Office Message',
                actionFn: function() {
                    el8.appshared.message.prePopulateNewMessage({
                        toDocId: item.getId()
                    });
                },
                indent: true
            });
            menu.push({
                actionText: 'Provider Letter',
                actionFn: function() {
                    el8.appchart.mgr.thirdpane.attachToLetter({
                        type: el8.util.consts.CONSULTANT_LETTER,
                        attachmentId: item.getId(),
                        enforceStrictTypeMatch: true
                    });
                },
                indent: true
            });
            menu.push({
                actionText: 'Provider Referral',
                actionFn: function() {
                    el8.appchart.mgr.thirdpane.attachToLetter({
                        type: el8.util.consts.REFERRAL_LETTER,
                        attachmentId: item.getId(),
                        enforceStrictTypeMatch: true
                    });
                },
                indent: true
            });
            if (el8Globals.FEATURES.PatientPortal) {
                menu.push({
                    actionText: 'Patient Letter',
                    actionFn: function() {
                        el8.appchart.mgr.thirdpane.attachToLetter({
                            type: el8.util.consts.PATIENT_LETTER,
                            attachmentId: item.getId()
                        });
                    },
                    indent: true
                });
            }

            if (!item.isImportedNote()) {
                // export
                menu.push({type: 'heading', actionText: 'Export to:'});
                // was "visit-note-more-trigger"
                menu.push({
                    actionText: 'New Note',
                    actionFn: function() {
                        el8.appchart.mgr.notes.cloneExistingNote(item.getId());
                    },
                    indent: true
                });
                menu.push({
                    actionText: 'New Note (HPI Only)',
                    actionFn: function() {
                        el8.appchart.mgr.notes.cloneExistingNote(item.getId(), {hpiOnly: true});
                    },
                    indent: true
                });
            }

            //
            // Right
            //

            // edit
            var addEditBillAction = function() {
                menu.push({
                    actionText: 'Edit Bill',
                    actionFn: function() {
                        el8.appchart.visitNote.billDialogMgr.show({
                            visitNote: item,
                            patient: el8.ptdata.currPatient,
                            source: 'chart feed',
                            successCb: function() { el8.ptdata.visitNotes.itemNotify(item); }
                        });
                    },
                    right: true
                });
            };
            if (!item.isImportedNote()) {
                if (el8Globals.FEATURES.CoSignature && el8.data.currUser.isPhysician()) {
                    menu.push({
                        actionText: 'Co-Sign Note',
                        actionFn: function() {
                            var visitNoteId = item.getId();
                            el8React.dispatch.openVisitNoteCoSignDialog({ visitNoteId: visitNoteId });
                            el8.util.amplitude.logCoSignVisitNoteStart(visitNoteId);
                        },
                        right: true
                    });
                }
                if (item.getSignUserId() === el8.data.currUser.getId()) {
                    // was "choose-edit-note-trigger"
                    menu.push({
                        actionText: 'Amend Note',
                        actionFn: function() {
                            el8.appchart.mgr.notes.tryAmendVisitNote(item);
                        },
                        right: true
                    });
                    addEditBillAction();

                } else if (currUserIsBillDelegateOfSigner(item.getSignUserId())) {
                    menu.push({type: 'line'});
                    addEditBillAction();
                }
            }

            // For unsigned notes in RA: allow editing and ack'ing by physicians
            //
            // TODO: check logic. delegates?
            if (!item.isSignedOff() && el8.data.currUser.isPhysician()) {
                addEditBillAction();

                if (bill && bill.getBillingStatus() !== el8.util.consts.BILLING_STATUS.UnresolvedError) {
                    menu.push({
                        actionText: 'Acknowledge Bill',
                        actionFn: function() { item.dismissBill(); },
                        right: true
                    });
                }
            }

            menu.push({
                actionText: 'Add or Edit Tags',
                actionFn: function(item) {
                    el8.appchart.dialog.docTags.show({doc: item});
                },
                right: true
            });
            if (item.isImportedNote()) {
                menu.push({
                    actionText: 'Change Report Category',
                    actionFn: function(item) {
                        el8.appchart.dialog.changeDocumentSubType.show(item);
                    },
                    right: true
                });
            }

            addConfidentialityAction(item, menu, true);

            // print
            menu.push({type: 'line', right: true});

            menu.push({type: 'heading', actionText: 'Print:', right: true, allowReadonly:true });

            // was "choose-print-note-trigger"
            menu.push({
                actionText: 'Note',
                actionFn: function() { item.printNote(false); },
                indent: true,
                right: true,
                allowReadonly: true
            });

            if (!item.isImportedNote()) {
                if (bill && !bill.isEmpty()) {
                    menu.push({
                        actionText: 'Note with Billing',
                        actionFn: function() { item.printNote(true); },
                        indent: true,
                        right: true,
                        allowReadonly: true
                    });
                }
                menu.push({
                    actionText: 'Encounter Summary (MIPS)',
                    actionFn: function() { item.printClinicalSummary(); },
                    indent: true,
                    right: true,
                    allowReadonly: true
                });
                if (item.hasPrintableMeaningfulUse()) {
                    menu.push({
                        actionText: (bill && !bill.isEmpty()) ?
                            'Note with Billing & MIPS Info' :
                            'Note with MIPS Info',
                        actionFn: function() { item.printNote(true, true); },
                        indent: true,
                        right: true,
                        allowReadonly: true
                    });
                }
                if (item.getBulletSets()['Instr'].all().length) {
                    menu.push({
                        actionText: 'Patient Instructions',
                        actionFn: function() {
                            var printPath = el8Globals['PATIENT_PATH']+"print/patient-instructions/"+item.getId() + "/";
                            window.open(printPath);
                        },
                        indent: true,
                        right: true,
                        allowReadonly: true
                    });
                }
                menu.push({
                    actionText: 'Patient Summary',
                    actionFn: function() { item.printPatientSummary(); },
                    indent: true,
                    right: true,
                    allowReadonly: true
                });
                if (bill && !bill.isEmpty()) {
                    menu.push({
                        actionText: 'Simple Invoice (no Dx)',
                        actionFn: function() { item.printSimplePatientInvoice(); },
                        indent: true,
                        right: true,
                        allowReadonly: true
                    });

                    // In the brave new ICD-10 world, it's a Very Bad Thing to submit a claim
                    // with both 10s and 9s because reasons. These two menu options only print
                    // one of the two codes sets.
                    if (!bill.hasUnstructuredDxs()) {
                        menu.push({
                            actionText: 'Claims Invoice with ICD-10',
                            actionFn: function() { item.printIcd10PatientInvoice(); },
                            indent: true,
                            right: true,
                            allowReadonly: true
                        });
                    }

                    menu.push({
                        actionText: 'Claims Invoice with ICD-9',
                        actionFn: function() { item.printIcd9PatientInvoice(); },
                        indent: true,
                        right: true,
                        allowReadonly: true
                    });
                }
                if (item.getRxIds().length) {
                    menu.push({
                        actionText: 'Reprint Prescribed Scripts',
                        actionFn: function() {
                            el8.ptdata.medOrders.printSet(item.getRxIds(), function() {
                                el8.appchart.mainFeeds.reqAct.remove(item);
                            });
                        },
                        indent: true,
                        right: true,
                        allowReadonly: true
                    });
                }
            }

            // organize (none)

            // random
            if (!item.isImportedNote() && item.getSignUserId() === el8.data.currUser.getId()) {
                if (el8Globals.FEATURES.MUReports) {
                    menu.push({type: 'line', right: true});
                    menu.push({
                        actionText: (!item.getAmendmentRequest() ? '' : 'Edit') + ' Pt Amendment Request',
                        actionFn: function() {
                            showAddEditAmendmentRequestDialog(item);
                        },
                        right: true
                    });
                }
            }

            // remove
            menu.push({type: 'line', right: true});

            menu.push({
                actionText: 'Remove',
                actionFn: function() {
                    el8.uiwidget.deleteConfirm("note",
                        function() { el8.ptdata.visitNotes.forceDeleteItem(item); }
                    );
                },
                right: true,
                type: 'remove'
            });
            if (item.getImages().length) {
                menu.push({
                    actionText: 'Remove & Refile Images',
                    actionFn: function() {
                        el8.uiwidget.deleteConfirm("note and send the images back to Incoming Documents",
                            function() { el8.ptdata.visitNotes.forceDeleteItemSendBackImages(item); }
                        );
                    },
                    right: true,
                    type: 'remove'
                });
            }

        } else if (el8.model.identify.isNonvisitNote(item)) {
            menu.push({
                actionText: 'Add or Edit Tags',
                actionFn: function(item) {
                    el8.appchart.dialog.docTags.show({doc: item});
                }
            });
            if (item.isImportedNote()) {
                menu.push({
                    actionText: 'Change Report Category',
                    actionFn: function(item) {
                        el8.appchart.dialog.changeDocumentSubType.show(item);
                    }
                });
            }

            addConfidentialityAction(item, menu);

            menu.push({type: 'line'});

            menu.push({type: 'heading', actionText: 'Send:'});
            menu.push({
                actionText: 'Office Message',
                actionFn: function() {
                    el8.appshared.message.prePopulateNewMessage({
                        toDocId: item.getId()
                    });
                },
                indent: true
            });
            menu.push({
                actionText: 'Provider Letter',
                actionFn: function() {
                    el8.appchart.mgr.thirdpane.attachToLetter({
                        type: el8.util.consts.CONSULTANT_LETTER,
                        attachmentId: item.getId()
                    });
                },
                indent: true
            });
            menu.push({
                actionText: 'Provider Referral',
                actionFn: function() {
                    el8.appchart.mgr.thirdpane.attachToLetter({
                        type: el8.util.consts.REFERRAL_LETTER,
                        attachmentId: item.getId(),
                        enforceStrictTypeMatch: true
                    });
                },
                indent: true
            });

            if (el8Globals.FEATURES.PatientPortal) {
                menu.push({
                    actionText: 'Patient Letter',
                    actionFn: function() {
                        el8.appchart.mgr.thirdpane.attachToLetter({
                            type: el8.util.consts.PATIENT_LETTER,
                            attachmentId: item.getId()
                        });
                    },
                    indent: true
                });
            }

            menu.push({type: 'heading', actionText: 'Export to Note:'});
            menu.push({
                actionText: 'as Data',
                actionFn: function() {
                    el8.appchart.mgr.notes.addReference({item: item});
                },
                indent: true
            });

            menu.push({type: 'line'});

            menu.push({
                actionText: 'Print',
                actionFn: function(item) {
                    el8.ptdata.nonvisitNotes.printNote(item);
                },
                allowReadonly: true
            });

            menu.push({type: 'line'});

            menu.push({
                actionText: 'Remove',
                actionFn: function(item) {
                    el8.uiwidget.deleteConfirm("note",
                        function() { el8.ptdata.nonvisitNotes.forceDeleteItem(item); }
                    );
                },
                type: 'remove'
            });
            if (item.getImages().length) {
                menu.push({
                    actionText: 'Remove & Refile Images',
                    actionFn: function(item) {
                        el8.uiwidget.deleteConfirm("note from the patient chart and send the images back to Incoming Documents",
                            function() { el8.ptdata.nonvisitNotes.deleteItemSendBackImages(item, false, true); }
                        );
                    },
                    type: 'remove'
                });
            }

        } else if (el8.model.identify.isOrder(item)) {

            if (el8Globals.FEATURES.BiDiLabs) {

                addOrderStatusActions(item, menu, source);

                var reminder = item.getReminder();
                if (reminder) {
                    menu.push({
                        actionText: 'Remind Later',
                        actionFn: function() {
                            el8.util.amplitude.logRemindLater(item.getModelClass());
                            reminder.getNewDate();
                        }
                    });

                    menu.push({type: 'line'});
                }
            }

            addOrderReorderAction(item, menu);

            addConfidentialityAction(item, menu);

            menu.push({type: 'line'});

            if (el8Globals.FEATURES.InHouseLabWorkflow) {
              addSpecimenCollectionActions(item, menu, source);
            }

            menu.push({type: 'heading', actionText: 'Send:'});

            menu.push({
                actionText: 'Office Message',
                actionFn: function() {
                    el8.appshared.message.prePopulateNewMessage({ toDocId: item.getId() });
                },
                indent: true
            });

            if (el8Globals.FEATURES.Letters) {
                menu.push({
                    actionText: 'Provider Letter',
                    actionFn: function() {
                        el8.appchart.mgr.thirdpane.attachToLetter({
                            type: el8.util.consts.CONSULTANT_LETTER,
                            attachmentId: item.getId()
                        });
                    },
                    indent: true
                });
                menu.push({
                    actionText: 'Provider Referral',
                    actionFn: function() {
                        el8.appchart.mgr.thirdpane.attachToLetter({
                            type: el8.util.consts.REFERRAL_LETTER,
                            attachmentId: item.getId(),
                            enforceStrictTypeMatch: true
                        });
                    },
                    indent: true
                });
            }

            if (el8Globals.FEATURES.PatientPortal) {
                menu.push({
                    actionText: 'Patient Letter',
                    actionFn: function() {
                        el8.appchart.mgr.thirdpane.attachToLetter({
                            type: el8.util.consts.PATIENT_LETTER,
                            attachmentId: item.getId()
                        });
                    },
                    indent: true
                });
            }

            menu.push({type: 'heading', actionText: 'Export to Note:'});
            menu.push({
                actionText: 'as Data',
                actionFn: function() {
                    el8.appchart.mgr.notes.addReference({item: item});
                },
                indent: true
            });

            menu.push({type: 'line'});

            menu.push({
                actionText: 'Print',
                actionFn: function(item) {
                    var printPath = el8.service.urls.get('printOrder', [item]);
                    if (el8Globals.APP === 'chart') {
                        el8.appchart.printService.open({
                            attachmentId: item.getId(),
                            url: printPath
                        });
                    } else {
                        window.open(printPath);
                    }
                    return false;
                },
                allowReadonly: true
            });

            if (item.getModelClass() === 'LabOrder') {
                addPrintSpecimenLabelsAction(item, menu);

                if (el8Globals.FEATURES.DYMOLabels) {
                  addDYMOLabelPrintingAction(item, menu);
                }
            }

            menu.push({type: 'line'});

            menu.push({
               actionText: 'Remove',
               actionFn: function(item) {
                    el8.uiwidget.deleteConfirm(
                        "order",
                        function() {
                            var entitySet = el8.ptdata.getEntitySet(item.getModelClass());
                            entitySet.deleteItem(item);
                        }
                    );
               },
               type: 'remove'
            });

        } else if (el8.model.identify.isDocumentReminderNotification(item)) {
            if (item.isSignedOff()) {
                menu.push({
                    actionText: 'Remove',
                    actionFn: function(item) {
                        el8.uiwidget.deleteConfirm(
                            "notification",
                            function() {
                                el8.ptdata.documentReminderNotifications.deleteItem(
                                    item,
                                    false,
                                    {
                                        successCb: function() {
                                            el8.appchart.mainFeeds.reqAct.update();
                                            el8.appchart.mainFeeds.chart.update();
                                        }
                                    }
                                );
                            }
                        );
                    },
                    type: 'remove'
                });
            }
            else {

                menu.push({type: 'heading', actionText: 'Order Status:'});
                menu.push({
                    actionText: 'Fulfilled',
                    actionFn: function() {
                        el8.util.amplitude.logChangeOrderStatus('fulfilled', source, item.getModelClass())
                        // Open the attachment dialog, passing in patientId
                        el8.app.shared.dialog.reportAttachments.show({
                            callbackFn: function (attachmentItems) {
                                if (attachmentItems.length) { // just one or none
                                    var attachment = attachmentItems[0];
                                    item.fulfill({resolvingDocumentId: attachment.getId()});
                                    el8.appchart.mainFeeds.reqAct.update();
                                    el8.appchart.mainFeeds.chart.update();
                                }
                            },
                            patientId: el8.ptdata.currPatient.getId()
                        });
                    },
                    indent: true
                });
                menu.push({
                    actionText: 'Canceled',
                    actionFn: function() {
                        el8.util.amplitude.logChangeOrderStatus('canceled', source, item.getModelClass())
                        item.cancel({
                            successCb: function() {
                                el8.appchart.mainFeeds.reqAct.update();
                                el8.appchart.mainFeeds.chart.update();
                            }
                        });
                    },
                    indent: true
                });
                menu.push({type: 'line'});
                menu.push({
                    actionText: 'Remind Later',
                    actionFn: function() {
                        item.remindLater({
                            successCb: function() {
                                el8.util.amplitude.logRemindLater(item.getModelClass());
                                el8.appchart.mainFeeds.reqAct.update();
                                el8.appchart.mainFeeds.chart.update();
                            }
                        });
                    }
                });
                menu.push({type: 'line'});
                menu.push({type: 'heading', actionText: 'Send:'});
                menu.push({
                    actionText: 'Office Message',
                    actionFn: function() {
                        el8.appshared.message.prePopulateNewMessage({ toDocId: item.getDocumentId() });
                    },
                    indent: true
                });
            }
        } else if (el8.model.identify.isReport(item)) {
            // send
            menu.push({type: 'heading', actionText: 'Send:'});
            menu.push({
                actionText: 'Office Message',
                actionFn: function() {
                    // we do some extra handling for reports to display the message in the reports dialog
                    el8.appchart.dialog.reports.writeReportMessage(item);
                },
                indent: true
            });

            if (el8Globals.FEATURES.Letters) {
                menu.push({
                    actionText: 'Provider Letter',
                    actionFn: function() {
                        el8.appchart.mgr.thirdpane.attachToLetter({
                            type: el8.util.consts.CONSULTANT_LETTER,
                            attachmentId: item.getId()
                        });
                    },
                    indent: true
                });
                menu.push({
                    actionText: 'Provider Referral',
                    actionFn: function() {
                        el8.appchart.mgr.thirdpane.attachToLetter({
                            type: el8.util.consts.REFERRAL_LETTER,
                            attachmentId: item.getId(),
                            enforceStrictTypeMatch: true
                        });
                    },
                    indent: true
                });
            }

            if (el8Globals.FEATURES.PatientPortal) {
                menu.push({
                    actionText: 'Patient Letter',
                    actionFn: function() {
                        el8.appchart.mgr.thirdpane.attachToLetter({
                            type: el8.util.consts.PATIENT_LETTER,
                            attachmentId: item.getId()
                        });
                    },
                    indent: true
                });
            }

            // export
            if(item.isSignedOff() && !isPatientFormCollection) {
                menu.push({type: 'heading', actionText: 'Export to Note:'});
                menu.push({
                    actionText: 'as HPI',
                    actionFn: function(item) {
                        el8.appchart.mgr.notes.addReference({item: item, sectionName: 'problem'});
                    },
                    indent: true
                });
                menu.push({
                    actionText: 'as HPI Subbullet',
                    actionFn: function(item) {
                        el8.appchart.mgr.notes.addProblemSubBullet(item);
                    },
                    indent: true
                });
                if (item.getReportType() === 'lab') {
                    menu.push({
                        actionText: 'as Data w/ Assoc. Probs',
                        actionFn: function(item) {
                            el8.appchart.mgr.notes.autoImportLabsProblems({
                                type: 'reports',
                                reportIds: [item.getId()]
                            });
                        },
                        indent: true
                    });
                    menu.push({
                        actionText: 'as Data w/ Past Dates',
                        actionFn: function(item) {
                            el8.appchart.mgr.notes.addReference({
                                item: item,
                                showPrevLabResultDates: true
                            });
                        },
                        indent: true
                    });
                }
                menu.push({
                    actionText: 'as Data',
                    actionFn: function(item) {
                        el8.appchart.mgr.notes.addReference({item: item});
                    },
                    indent: true
                });
            }

            //
            // right column
            //

            // edit
            if (item.hasImages() && !item.isSignedOff()) {
                var annotationSource = source === 'report dialog' ? 'reports panel' : 'requiring actions';
                var pageTotal = item.getFullSizeImages().length;
                menu.push({
                    actionText: 'Annotate',
                    actionFn: function(item) {
                        el8React.dispatch.openAnnotationsDialog({
                            reportId: item.getId()
                        });
                        el8.util.amplitude.logAnnotateReportV2(annotationSource, item.getId(), item.getReportType(), pageTotal);
                    },
                    right: true
                });
            }
            menu.push({
                actionText: 'Edit Details',
                actionFn: function(item) {
                    el8.appchart.dialog.editReportDetails.show(item);
                },
                right: true
            });

            if (item.getReportType() === 'lab' && item.isAllowManualEdit() &&
                !item.getLastManualEditTime()) {
                // Only Labs without integrations should allow manual add AND
                // that don't already have manual values
                menu.push({
                    actionText: 'Add Lab Values for Trending',
                    actionFn: function(item) {
                        // Not using new POC dlg here, want to use old 2-pane dlg
                        // since it allows any type of result to be entered
                        el8.appchart.dialog.addDiscreteLabValues.show(item.getId());
                    },
                    right: true
                });
            }

            if (!item.getLastManualEditTime() && !isPatientFormCollection) {
                // Don't show this if any manual results
                menu.push({
                    actionText: 'Mark Previous as Partial',
                    actionFn: function(item) {
                        el8.render.content.renderPreviousReportAsPartial(item);
                    },
                    right: true
                });
            }

            addConfidentialityAction(item, menu, true);

            // print
            menu.push({type: 'line', right: true});
            menu.push({
                actionText: 'Print',
                actionFn: function(item) {
                    item.printReport();
                },
                right: true,
                allowReadonly: true
            });

            // organize
            menu.push({type: 'line', right: true});
            if (!isPatientFormCollection && ((item.getReportType() !== 'lab') || !item.hasGrids() )) {
                menu.push({
                    actionText: 'Append to Other Report',
                    actionFn: function(item) {
                        el8.render.content.renderMergeIntoReport(item);
                    },
                    right: true
                });
            }
            menu.push({
                actionText: 'Refile to Other Patient Chart',
                actionFn: function(item) {
                    el8.appshared.dialog.reassignPatient.show({
                        docId: item.getId()
                    });
                },
                right: true
            });
            if (!item.isSignedOff() &&
                !(
                    el8.data.practiceUsers.isSinglePhysicianPractice()
                    || el8.data.practiceUsers.isVirtualSinglePhysicianPractice(item.getReviewUserId())
                )
            ) {
                menu.push({
                    actionText: 'Reassign to Other Provider',
                    actionFn: function(item) {
                        el8.appshared.dialog.reassignReviewUser.show({
                            report: item,
                            successCb: function() {
                                el8.appchart.mainFeeds.reqAct.update();
                            }
                        });
                    },
                    right: true
                });
            }

            // remove
            menu.push({type: 'line', right: true});
            menu.push({
                actionText: 'Remove',
                actionFn: function(item) {
                    item.deleteReport();
                },
                right: true,
                type: 'remove'
            });

            if ((item.getReportType() !== 'lab' || !item.hasGrids()) && !isPatientFormCollection) {
                menu.push({
                    actionText: 'Remove & Refile Images',
                    actionFn: function(item) {
                        item.deleteReport(true);
                    },
                    right: true,
                    type: 'remove'
                });
            }

        } else if (el8.model.identify.isThread(item)) {

            if(!item.isReviewed() && item.isSignedOff() && item.getCurrMember()) {
                menu.push({
                    actionText: 'Acknowledge',
                    actionFn: function(item) {
                        el8.appshared.message.acknowledgeThread(item);
                    }
                });
            }

            if(!item.isSignedOff() && item.getCurrMember()) {
                menu.push({
                    actionText: 'Reply',
                    actionFn: function(item) {
                        var cardContainer = $('#patient-feed-container');
                        el8.appshared.message.showReplyMessageForm(item, cardContainer);
                    }
                });
            }

            if(!item.isReviewed()) {
                menu.push({type: 'heading', actionText: 'Write:'});
                menu.push({
                    actionText: 'Rx Script',
                    actionFn: function(item) {
                        el8.appchart.mgr.orderForm.showMedsOrderForm();
                    },
                    indent: true
                });
                menu.push({
                    actionText: 'Referral',
                    actionFn: function(item) {
                        el8.appchart.mgr.orderForm.showReferralOrderForm();
                    },
                    indent: true
                });
                menu.push({
                    actionText: 'Lab Order',
                    actionFn: function(item) {
                        el8.appchart.mgr.orderForm.showLabOrderForm();
                    },
                    indent: true
                });
                menu.push({
                    actionText: 'Imaging Order',
                    actionFn: function(item) {
                        el8.appchart.mgr.orderForm.showImagingOrderForm();
                    },
                    indent: true
                });
                menu.push({
                    actionText: 'Cardiac Order',
                    actionFn: function(item) {
                        el8.appchart.mgr.orderForm.showCardiacOrderForm();
                    },
                    indent: true
                });
                menu.push({
                    actionText: 'Sleep Order',
                    actionFn: function(item) {
                        el8.appchart.mgr.orderForm.showSleepOrderForm();
                    },
                    indent: true
                });
                menu.push({
                    actionText: 'Pulmonary Order',
                    actionFn: function(item) {
                        el8.appchart.mgr.orderForm.showPulmonaryOrderForm();
                    },
                    indent: true
                });
            }

            menu.push({
                actionText: 'Print',
                actionFn: function(item) {
                    var printUrl = el8.service.urls.get('printMessageThread', [item, el8.ptdata.currPatient.getId()]);
                    window.open(printUrl);
                },
                allowReadonly: true
            });

            menu.push({type: 'line'});

            menu.push({
               actionText: 'Remove',
               actionFn: function(item) {
                    el8.uiwidget.deleteConfirm(
                        "message thread",
                        function() { el8.ptdata.messageThreads.deleteItem(item); }
                    );
               },
               type: 'remove'

            });

        } else if (el8.model.identify.isDiscontinueMedOrder(item)) {
            // TODO NewChartFeed remove chartFeed param after transition? Also below
            return el8.appchart.actions.dcMedOrderNew({item: item, fromRA: fromRA, chartFeed: true});

        } else if (el8.model.identify.isPrescription(item)) {
            return el8.appchart.actions.medOrderNew({item: item,  fromRA: fromRA, chartFeed: true});

        } else if (el8.model.identify.isDenialMedOrder(item)) {
            menu.push({
                actionText: 'Remove',
                actionFn: function(item) {
                    el8.uiwidget.deleteConfirm(
                        "denial notification",
                        function() { el8.ptdata.denialMedOrders.deleteItem(item); }
                    );
                },
                type: 'remove'
            });
        } else if (el8.model.identify.isLetter(item)) {

            if (item.isReferralLetter()) {
                //
                //  Letters can contain referralOrders that have resolution
                //  states and can be reordered.
                //
                var referralOrder = item.getReferralOrder();

                if (el8Globals.FEATURES.BiDiLabs) {
                    addOrderStatusActions(referralOrder, menu, source);
                }

                addOrderReorderAction(referralOrder, menu);

                menu.push({type: 'line'});
            }

            if (item.isSignedOff()) {
                if (item.getFaxStatus()) {
                    // should only be possible to re-fax letters that were previously faxed
                    menu.push({
                        actionText: 'Refax',
                        actionFn: function(letter) {
                            el8.appchart.dialog.refaxLetter.show(letter);
                        }
                    });
                    menu.push({type: 'line'});
                }

                menu.push({type: 'heading', actionText: 'Send:'});

                menu.push({
                    actionText: 'Office Message',
                    actionFn: function(letter) {
                        el8.appshared.message.prePopulateNewMessage({
                            toDocId: letter.getId()
                        });
                    },
                    indent: true
                });

                menu.push({type: 'line'});

                menu.push({type: 'heading', actionText: 'Export to Note:'});

                menu.push({
                    actionText: 'as Tx',
                    actionFn: function(item) {
                        el8.appchart.mgr.notes.addReference({item: item});
                    },
                    indent: true
                });
                menu.push({
                    actionText: 'as Data',
                    actionFn: function(item) {
                        el8.appchart.mgr.notes.addReference({item: item, sectionName: 'data'});
                    },
                    indent: true
                });

                menu.push({type: 'line'});

                if (item.isWithArchive()) {
                    // withArchive -> if the ZIP exists, make it clear they won't be printing and if not,
                    // don't let them try to download yet (but leave a placeholder action behind)
                    if (item.isProcessed()) {
                        menu.push({
                            actionText: 'Download Archive',
                            actionFn: function(letter) { window.open(el8.service.urls.get('downloadZipLetter', [letter])); }
                        });
                    } else {
                        menu.push({
                            actionSafeText: '<span class="disabled">Preparing Archive&hellip;</span>',
                            actionFn: function() {} // noop
                        });
                    }
                }

                if (item.isProcessed()) {
                    menu.push({
                        actionText: 'Print',
                        actionFn: function(letter) { window.open(el8.service.urls.get('printPdfLetter', [letter])); },
                        allowReadonly: true
                    });
                } else {
                    menu.push({
                        actionSafeText: '<span class="disabled">Preparing PDF&hellip;</span>',
                        actionFn: function() {}, // noop
                        allowReadonly: true
                    });
                }

                if (!item.isSendToPatient()) {
                    menu.push({
                        actionText: 'Print Patient Copy',
                        actionFn: function(letter) {
                            window.open(el8.service.urls.get('printLetterPtCopy', [letter]));
                        },
                        allowReadonly: true
                    });
                }

                if (el8Globals.FEATURES['DocTagsForLetters']) {
                    menu.push({
			actionText: 'Add or Edit Tags',
			actionFn: function(letter) {
                            el8.appchart.dialog.docTags.show({doc: letter});
			},
                    });
		};

                menu.push({type: 'line'});

                menu.push({
                    actionText: 'Remove',
                    actionFn: function(letter) {
                        var deleteLetter = function() {
                            el8.ptdata.letters.deleteItem(letter);
                        };
                        el8.uiwidget.deleteConfirm("letter", deleteLetter);
                    },
                    type: 'remove'
                });
            }
        } else if (item.is('LetterReceipt')) {
            if (item.isSignedOff() && !item.isPtLetter()) {
                menu.push({
                    actionText: 'Reply',
                    actionFn: function(receipt) {
                        var $receiptItem = el8.appchart.mainFeeds.chart.getRenderItem(receipt.getId());
                        $receiptItem.find('.letter-toggle-collapse-trigger').trigger('el8_expand');
                        $receiptItem.find('.comment-reply-trigger').click();
                        $(':input[name="replyBody"]', $receiptItem).focusFocus();
                    }
                });
            }

            menu.push({type: 'line'});

            menu.push({type: 'heading', actionText: 'Send:'});

            menu.push({
                actionText: 'Office Message',
                actionFn: function(receipt) {
                    el8.appshared.message.prePopulateNewMessage({
                        toDocId: receipt.getId()
                    });
                },
                indent: true
            });

            menu.push({type: 'heading', actionText: 'Export to Note:'});

            menu.push({
                actionText: 'as Tx',
                actionFn: function(receipt) {
                    el8.appchart.mgr.notes.addReference({item: receipt});
                },
                indent: true
            });
            menu.push({
                actionText: 'as Data',
                actionFn: function(receipt) {
                    el8.appchart.mgr.notes.addReference({item: receipt, sectionName: 'data'});
                },
                indent: true
            });

            menu.push({type: 'line'});

            menu.push({
                actionText: (item.isWithArchive()) ? 'Download Archive' : 'Print',
                actionFn: function(receipt) {
                    window.open(el8.service.urls.get('printLetterReceipt', [receipt]));
                },
                allowReadonly: true
            });

            menu.push({type: 'line'});

            var dividerNeeded = false;
            if (item.isSignedOff() && !item.getFiledAsDocumentId() && !item.isPtLetter()) {
                menu.push({
                    actionText: 'File as Consult Report',
                    actionFn: function(receipt) {
                        receipt.fileReport(el8.util.consts.RECEIPT_BODY_ATTACHMENT);
                    }
                });
                dividerNeeded = true;
            }
            if (dividerNeeded) {
                menu.push({type: 'line'});
            }

            if (!item.isReferralLetter()) {
                menu.push({
                    actionText: 'Remove',
                    actionFn: function(receipt) {
                        el8.uiwidget.deleteConfirm(
                            "letter",
                            function() { el8.ptdata.letterReceipts.deleteItem(receipt); }
                        );
                    },
                    type: 'remove'
                });
            }

        } else if (item.is('UnreadLetterNotification')) {
            if (item.isSignedOff()) {
                menu.push({
                    actionText: 'Remove',
                    actionFn: function(item) {
                        el8.uiwidget.deleteConfirm(
                            "notification",
                            function() { el8.ptdata.unreadLetterNotifications.deleteItem(item); }
                        );
                    },
                    type: 'remove'
                });

            } else {
                menu.push({type: 'heading', actionText: 'Send:'});
                menu.push({
                    actionText: 'Office Message',
                    actionFn: function(letter) {
                        el8.appshared.message.prePopulateNewMessage({
                            toDocId: item.getLetter().getId()
                        });
                    },
                    indent: true
                });
                menu.push({type: 'line'});
                menu.push({
                    actionText: 'Acknowledge & Sign off',
                    actionFn: function(item) {
                        item.acknowledgeAndSignOff();
                    }
                });
                menu.push({
                    actionText: 'Notify Me Again Later',
                    actionFn: function(item) {
                        el8.appchart.letters.dialog.updateUnreadAlertNotification.show(item);
                    }
                });
            }

        } else if( el8.model.identify.isCheckout(item) ) {
            // TODO: this looks unused. confirm and remove
            menu.push({
                actionText: 'Acknowledge',
                actionFn: function(item) {
                    item.save( function() {
                        // Assumes it has chart feed item ID, and callbackFn is to remove this item
                        $('#' + el8.util.feed.getChartFeedItemId(item) ).remove();
                    });
                }
            });

        } else if(el8.model.identify.isPatientHistory(item)) {
            // TODO: not a main feed item, but used by the refpanel
            var historyItem = item;
            var itemId = historyItem.getId();
            var itemType = historyItem.getType();

            menu.push({
                actionText: 'Edit',
                actionFn : function() {
                    el8.appchart.refpanel.history.editItem(itemId, itemType);
                }
            });
            menu.push({
                actionText: 'Export to Note',
                actionFn : function() {
                    el8.appchart.mgr.notes.addReference({item: historyItem });
                }
            });
            menu.push({
                actionText: 'Remove',
                actionFn: function() {
                    el8.appchart.refpanel.history.removeItem(itemId, itemType);
                }
            });

        } else if (item.getModelClass() === 'PatientFamilyHistoryItem') {

            var familyItem = item;

            menu.push({
                actionText: 'Edit',
                actionFn : function() {
                    el8.appchart.refpanel.family.editItem(familyItem.getId());
                }
            });
            menu.push({
                actionText: 'Export to Note',
                actionFn : function() {
                    el8.appchart.mgr.notes.addReference({item: familyItem });
                }
            });
            menu.push({
                actionText: 'Remove',
                actionFn: function() {
                    el8.appchart.refpanel.family.removeItem(familyItem.getId());
                }
            });

        } else if(el8.model.identify.isConfidentialItem(item)) {

            menu.push({
                actionText: 'Edit',
                actionFn : function() {
                    var itemId = (item) ? item.getId() : null;
                    el8.appchart.refpanel.confidential.editItem(itemId);
                }
            });
            menu.push({
                actionText: 'Remove',
                actionFn: function() {
                    var itemId = (item) ? item.getId() : null;
                    el8.appchart.refpanel.confidential.removeItem(itemId);
                }
            });

        } else if (item.is('DocumentAddendum')) {
            var itemId = item.getId();

            menu.push({
                actionText: 'Export to Note',
                actionFn : function() {
                    el8.appchart.mgr.notes.addReference({item: item});
                }
            });

            menu.push({type: 'line'});

            menu.push({
                actionText: 'Remove',
                actionFn: function() {
                    el8.uiwidget.deleteConfirm("addendum",
                        function() {
                            el8.ptdata.addendums.deleteItem(itemId);
                        }
                    );
                },
                type: 'remove'
            });

        } else if (item.is('RxHistoryDownloadSummary')) {

            if (el8.appchart.permissions.allow('acknowledgeRxDownloads') && !item.isSignedOff()) {

                // the regular Sign action has its own button in actions.js

                if (el8Globals.FEATURES['MedsHxIgnore']) {
                    menu.push({
                        actionText: 'Sign Off & Do NOT Add to Med List',
                        actionFn: function() {
                            el8.appchart.medsMgr.acknowledgeNoMergeRxDownloadSummary(item.getId());
                        }
                    });
                    menu.push({type: 'line'});
                }
            }

            menu.push({
                actionText: 'Export to Note as Data',
                actionFn: function() {
                    el8.appchart.mgr.notes.addReference({item: item});
                }
            });

            menu.push({
                actionText: 'Print',
                actionFn: function() {
                    window.open(el8.service.urls.get('printRxHistoryDownloadSummary', [item.getId()]));
                },
                allowReadonly: true
            });

            if (el8.data.currUser.isElationStaff()) {
                menu.push({
                   actionText: 'Remove',
                   actionFn: function(item) {
                        el8.uiwidget.deleteConfirm(
                            "Rx History Download",
                            function() {
                                var entitySet = el8.ptdata.getEntitySet(item.getModelClass());
                                entitySet.deleteItem(item);
                            }
                        );
                   },
                   type: 'remove'
                });
            }

        } else if (item.is('XmlPatientSummary')) {
            menu.push({
                actionText: 'Download Original XML',
                actionFn: function(summary) {
                    window.open(summary.getDownloadUrl());
                }
            });

            menu.push({type: 'line'});

            menu.push({
                actionText: 'Remove',
                actionFn: function(summary) {
                    el8.uiwidget.deleteConfirm(
                        "item",
                        function() { el8.ptdata.xmlSummaries.deleteItem(summary); }
                    );
                },
                type: 'remove'
            });

        } else if (item.is('PatientCollaboratorNotification')) {
            menu.push({
                actionText: 'Remove',
                actionFn: function(notification) {
                    el8.uiwidget.deleteConfirm(
                        "item",
                        function() { el8.ptdata.plrCollaboratorNotifications.deleteItem(notification); }
                    );
                },
                type: 'remove'
            });
        } else if (item.is('VipAccessNotification')) {
            // The primary provider can remove these notifications - no one else can
            if (el8.data.currUser.isPhysician() &&
                (el8.ptdata.currPatient.getPrimaryPhysicianUserId() === el8.data.currUser.getId())) {
                menu.push({
                    actionText: 'Remove',
                    actionFn: function(notification) {
                        el8.uiwidget.deleteConfirm(
                            "item",
                            function() { el8.ptdata.vipAccessNotifications.deleteItem(notification); }
                        );
                    },
                    type: 'remove'
                });
            } else {
                menu.push({
                    actionSafeText: '<span class="disabled">Remove</span>',
                    actionFn: function() {} // noop
                });
            }
        } else if (item.is('PmpCheckNotification')) {
            menu.push({type: 'heading', actionText: 'Export to Note:'});
            menu.push({
                actionText: 'as Data',
                actionFn: function() {
                    el8.appchart.mgr.notes.addReference({item: item});
                    el8.util.amplitude.logPMPExportedNote();
                },
                indent: true
            });
            menu.push({type: 'line'});
            menu.push({type: 'heading', actionText: 'Send:'});
            menu.push({
                actionText: 'Office Message',
                actionFn: function() {
                    el8.appshared.message.prePopulateNewMessage({
                        toDocId: item.getId()
                    });
                    el8.util.amplitude.logPMPCheckSentMessage();
                },
                indent: true
            });
            menu.push({type: 'line'});
            menu.push({
                actionText: 'Remove',
                actionFn: function(summary) {
                    el8.uiwidget.deleteConfirm(
                        "item",
                        function() { el8.ptdata.pmpCheckNotifications.deleteItem(summary); }
                    );
                    el8.util.amplitude.logPMPRemovedFromRecord();
                },
                type: 'remove'
            });
        } else if (item.is('PrenatalFlowsheetVisitMeasurements')) {
            menu.push({
                actionText: 'View Flowsheet',
                actionFn: function(visitMeasurements) {
                    el8.appchart.dialog.prenatalFlowsheet.show({'ptPrenatalFlowsheet': visitMeasurements.getFlowsheet()});
                },
                allowReadonly: true
            });
            menu.push({
                actionText: 'Print Flowsheet',
                actionFn: function(visitMeasurements) {
                    visitMeasurements.getFlowsheet().print();
                },
                allowReadonly: true
            });
            menu.push({type: 'line'});
            menu.push({
                actionText: 'Delete Prenatal Visit',
                actionFn: function(visitMeasurements) {
                    el8.uiwidget.deleteConfirm(
                        'prenatal visit',
                        function() { visitMeasurements.deleteVisitMeasurements(); }
                    );
                },
                type: 'remove'
            });
        }

        // Rather than wrap each menu item in an if statement, remove all items here that should not be
        // shown in read-only mode
        if (el8Globals.READ_ONLY) {
            menu = _.filter(menu, function (item) { return item.allowReadonly; });
        }

        return menu;
    };

})();
